import { convertToCurrency } from "../utility/utility.js";
import { convertRuntime } from "../utility/utility.js";

import {
  api_key,
  root_endpoint,
  sampleId,
  sampleName,
  getDb,
  pathEndpoints,
  getGenreList,
  getConfig,
} from "./apiSetUp.js";

export async function search_info(searchQuery, type_of_info) {
  const additional_endpoints = "&query=" + searchQuery.replace(/ /g, '%20');;
  const endpoints =
    root_endpoint +
    pathEndpoints[type_of_info] +
    api_key +
    additional_endpoints +
    "&include_adult=false";
    console.log(endpoints)
  const data = await getDb(endpoints);
  console.log(data)
  return data;
}

/*
search_info("Benedetta", "searchMulti").then((res) => {
    let results = res.results;
    for (let result of results){
        console.log(result.media_type)
    }
});*/